/* globals location */
export default (state, update) => update;



// WEBPACK FOOTER //
// ./datastore/actions/update-query-params.js